export const REDUX_NAMESPACE = 'TEMPLATE_TAGS';

export const TEMPLATE_TAG_TYPE = {
  CHANNEL: 'TEMPLATE_TAG_CATEGORY_CHANNEL',
  CUSTOM: 'TEMPLATE_TAG_CATEGORY_CUSTOM',
  FEATURE: 'TEMPLATE_TAG_CATEGORY_FEATURE',
  INDUSTRY: 'TEMPLATE_TAG_CATEGORY_INDUSTRY',
  MEDIA_TYPE: 'TEMPLATE_TAG_CATEGORY_MEDIA_TYPE',
  OBJECTIVE: 'TEMPLATE_TAG_CATEGORY_OBJECTIVE',
  TYPE: 'TEMPLATE_TAG_CATEGORY_TYPE',
  STYLE: 'TEMPLATE_TAG_CATEGORY_STYLE',
};

export const VALID_TEMPLATE_TAG_TYPES = new Set([
  TEMPLATE_TAG_TYPE.CUSTOM,
  TEMPLATE_TAG_TYPE.FEATURE,
  TEMPLATE_TAG_TYPE.OBJECTIVE,
  TEMPLATE_TAG_TYPE.STYLE,
  TEMPLATE_TAG_TYPE.TYPE,
]);

// tag types divided by org and given a specific order
export const ORGANIZATION_TEMPLATE_TAG_TYPES = [TEMPLATE_TAG_TYPE.OBJECTIVE];

// tag types divided by pub and given a specific order
export const PUBLISHER_TEMPLATE_TAG_TYPES = [
  TEMPLATE_TAG_TYPE.TYPE,
  TEMPLATE_TAG_TYPE.STYLE,
];

export const AUTO_SNAP_TEMPLATE_TAG_NAME = 'Web Import';
